/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var VariableFuelVariableLoadSeaShippingMethod;
(function (VariableFuelVariableLoadSeaShippingMethod) {
    let vessel_type;
    (function (vessel_type) {
        vessel_type["SEA_BULK_CARRIER_MEDIUM"] = "sea_bulk_carrier_medium";
        vessel_type["SEA_BULK_CARRIER_LARGE"] = "sea_bulk_carrier_large";
    })(vessel_type = VariableFuelVariableLoadSeaShippingMethod.vessel_type || (VariableFuelVariableLoadSeaShippingMethod.vessel_type = {}));
    let fuel;
    (function (fuel) {
        fuel["HFO"] = "HFO";
        fuel["MGO"] = "MGO";
    })(fuel = VariableFuelVariableLoadSeaShippingMethod.fuel || (VariableFuelVariableLoadSeaShippingMethod.fuel = {}));
    let load;
    (function (load) {
        load["AVERAGE"] = "average";
        load["HEAVY"] = "heavy";
    })(load = VariableFuelVariableLoadSeaShippingMethod.load || (VariableFuelVariableLoadSeaShippingMethod.load = {}));
})(VariableFuelVariableLoadSeaShippingMethod || (VariableFuelVariableLoadSeaShippingMethod = {}));
//# sourceMappingURL=VariableFuelVariableLoadSeaShippingMethod.js.map